import $ from 'jquery';

/**
 * Change read-only field to allow editing
 */
class FieldUnlock {
    constructor() {
        const $fieldUnlockBtn = $('.js-unlock-field-btn');

        $fieldUnlockBtn.on('click', function () {
            let target = '.js-unlock-target';

            if ($(this).data('unlock-target')) {
                target = $(this).data('unlock-target');
            }

            $(this).closest('.js-unlock-wrapper')
                .find(target)
                .find('button, input, select')
                .prop('readonly', false)
                .removeAttr('disabled')
                .focus();

            $(this).hide();

            $(this).after('<button class="o-form__button js-required-submit" type="submit">Save changes</button>');
        });
    }
}

export default FieldUnlock;
